<template>
  <div class="mc-video-history-new__timeline-bar-section-wrapper">
    <div class="mc-video-history-new__playlist-left-section-wrapper">
      <div class="mc-video-history-new__playlist-control-timeline-wrapper">
        <TimelineSearch
          :searchDisabled="videoChannelActive.length === 0"
          @goToDatetime="handleGoToDatetime"
        />
        <div class="mc-video-history-new__playlist-toggle-play-wrapper">
          <i
            v-if="isThereIsChannelPlaying"
            class="mc-icon icon-fill_pause"
            @click="handleClickPause"
          ></i>
          <i
            v-else
            class="mc-icon icon-fill_play"
            :class="{ disabled: videoChannelActive.length === 0 }"
            @click="handleClickPlay"
          ></i>
        </div>
      </div>

      <div class="mc-video-history-new__checkbox-channels-wrapper">
        <div
          v-for="ch in normalizedChannel"
          :key="Number(ch)"
          class="mc-video-history-new__checkbox-channel-item"
        >
          <McCheckbox
            v-model="mapCheckedChannel[ch]"
            :label="
              $t('trackVideo.camera') +
              ' ' +
              (Number(statusText.split(',').findIndex((c) => Number(c) === Number(ch))) + 1)
            "
            :disabled="loadingFilelist"
            @change="handleCheckboxChanges(Number(ch), $event)"
          />
          <!-- TODO : Uncomment when ready -->
          <!-- <div class="mc-video-history-new__thumbnail-per-chanel-wrapper">
            <b-skeleton v-if="mapThumbnailUrlPerChannel[ch]?.isGeneratingThumbnail" />
            <img
              v-if="mapThumbnailUrlPerChannel[ch]?.thumbUrl"
              :src="mapThumbnailUrlPerChannel[ch].thumbUrl"
            />
          </div> -->
        </div>
      </div>
    </div>
    <TimelineBar
      ref="timelineBarRef"
      :statusText="statusText"
      :deviceTypeActive="deviceTypeActive"
      @intentTimeChanges="intentTimeChanges"
    />
  </div>
</template>

<script>
import McCheckbox from '@/components/McCheckbox'
import TimelineBar from './TimelineBar.vue'
import TimelineSearch from '../TimelineSearch.vue'
import { Helper } from '@/mixin/helper'
import { mapState, mapGetters } from 'vuex'
import moment from 'moment'
moment.locale('id')

export default {
  components: {
    TimelineSearch,
    McCheckbox,
    TimelineBar,
  },
  mixins: [Helper],
  props: {
    statusText: {
      type: String,
      required: false,
      default: '',
    },
    deviceTypeActive: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      mapCheckedChannel: {},
    }
  },
  computed: {
    ...mapState('videoHistory', [
      'loadingFilelist',
      'vehicleStatuses',
      'vehicleIdActive',
      'mapWebviewStatePerChannel',
      'videoChannelActive',
      'mapFilelist',
      'vehicleStatuses',
      'vehicleIdActive',
      'period',
      'mapThumbnailUrlPerChannel',
      'mapWebviewBufferedTimePerChannel',
    ]),
    ...mapGetters('videoHistory', [
      'markerTimelineDate',
      'deviceTimezone',
      'isThereIsWebviewActive',
      'checkThereIsFilelistInsideChannel',
    ]),
    bufferedTimeState() {
      return (channel) => this.mapWebviewBufferedTimePerChannel[channel]
    },
    imei() {
      const imei = this.vehicleStatuses[this.vehicleIdActive]?.vehicle?.imei
      return imei
    },
    isThereIsChannelPlaying() {
      const isThereIsPlay = Object.values(this.mapWebviewStatePerChannel).some(
        (state) =>
          state === 'CONNECTING' || state === 'PLAYING' || state === 'FREEZE' || state === 'LOAD'
      )
      return isThereIsPlay
    },
    normalizedChannel() {
      return this.statusText.split(',').map((ch) => {
        let normalizedCh = Number(ch)
        if (this.deviceTypeActive === 'jc') normalizedCh = normalizedCh + 1
        return normalizedCh
      })
    },
  },

  watch: {
    videoChannelActive(val) {
      this.normalizedChannel.forEach((ch) => {
        if (val.includes(ch) && !this.mapCheckedChannel[ch]) {
          this.$set(this.mapCheckedChannel, ch, true)
        } else if (!val.includes(ch)) {
          this.$set(this.mapCheckedChannel, ch, false)
        }
      })
    },
  },

  async mounted() {
    while (this.loadingFilelist || !this.vehicleStatuses[this.vehicleIdActive]) {
      await new Promise((resolve) => setTimeout(resolve, 100))
    }

    this.normalizedChannel.forEach((ch) => {
      this.$set(this.mapCheckedChannel, ch, this.videoChannelActive.includes(ch))
    })
  },
  methods: {
    intentTimeChanges() {
      this.initAndPlayVideo()
    },
    handleClickPause() {
      Object.entries(this.mapWebviewStatePerChannel).forEach(([ch, state]) => {
        if (!state || state === 'NOT_STARTED' || state === 'LOAD') return

        this.$store.dispatch('videoHistory/postToStreamIframe', {
          channel: ch,
          imei: this.imei,
          payload: {
            type: 'VIDEO_HISTORY_TOGGLE_PAUSED',
            data: { isPaused: true, imei: this.imei, channel: ch },
          },
        })
      })
    },
    handleClickPlay() {
      const isAllNotStarted = Object.values(this.mapWebviewStatePerChannel)
        .filter((s) => s !== null)
        .every((state) => state === 'NOT_STARTED')

      if (isAllNotStarted) {
        this.initAndPlayVideo()
      }

      Object.entries(this.mapWebviewStatePerChannel).forEach(([ch, state]) => {
        if (state === 'PAUSED') {
          this.$store.dispatch('videoHistory/postToStreamIframe', {
            channel: ch,
            imei: this.imei,
            payload: {
              type: 'VIDEO_HISTORY_TOGGLE_PAUSED',
              data: { isPaused: false, imei: this.imei, channel: ch },
            },
          })
        }
      })
    },
    initAndPlayVideo() {
      const channelActive = this.videoChannelActive

      if (channelActive.length === 0) return

      const startBufferedTime = this.markerTimelineDate

      channelActive.forEach((ch) => {
        const isThereFilelist = this.mapFilelist[ch]?.some((fl) => {
          const utcStart = this.getUtcDateFromLocalDate(fl.startTime, this.deviceTimezone)
          const utcEnd = this.getUtcDateFromLocalDate(fl.endTime, this.deviceTimezone)
          return (
            this.isBetweenDate(startBufferedTime, utcStart, utcEnd) ||
            utcStart === startBufferedTime
          )
        })
        if (!isThereFilelist) return
        this.$store.dispatch('videoHistory/playChannel', ch)
      })

      this.$refs.timelineBarRef._zoomToMaxAtPosition()
    },
    async handleCheckboxChanges(channel, val) {
      if (val) {
        this.$store.dispatch('videoHistory/addChannelToGridWebview', channel)
        const isThereFIlelist = this.checkThereIsFilelistInsideChannel(channel)
        if (!isThereFIlelist) return
        if (!this.isThereIsChannelPlaying) return
        this.$store.commit('videoHistory/setHasIntentToTimeChange', true)
        await this.$nextTick()
        this.initAndPlayVideo()
      } else {
        this.$store.dispatch('videoHistory/removeChannelToGridWebview', channel)
      }
    },
    async handleGoToDatetime(datetime) {
      const dateActive = this.convertUtcToLocalDate(this.period[0], this.deviceTimezone)

      const arr = dateActive.split('T')
      arr[1] = datetime
      const newDateActive = arr.join('T')

      this.$refs.timelineBarRef.goToMarkerPosition(
        this.getUtcDateFromLocalDate(newDateActive, this.deviceTimezone)
      )

      const targetChannelBuffered = []

      this.videoChannelActive.forEach((ch) => {
        const buffered = this.bufferedTimeState(ch)
        if (buffered && this.isBetweenDate(newDateActive, buffered.start, buffered.end)) {
          targetChannelBuffered.push(ch)
          if (this.isThereIsWebviewActive) {
            this.$store.dispatch('videoHistory/postToStreamIframe', {
              imei: this.imei,
              channel: ch,
              payload: {
                type: 'VIDEO_HISTORY_SEEK',
                data: {
                  channel: ch,
                  imei: this.imei,
                  dateTime: newDateActive,
                },
              },
            })
          }
        }

        const filelist = this.mapFilelist[ch] ?? []

        const isThereFilelist = filelist.some((f) => {
          const utcStartTime = this.getUtcDateFromLocalDate(f.startTime, this.deviceTimezone)
          const utcEndTime = this.getUtcDateFromLocalDate(f.endTime, this.deviceTimezone)
          return (
            this.isBetweenDate(newDateActive, utcStartTime, utcEndTime) ||
            new Date(datetime).getTime() === new Date(utcStartTime).getTime()
          )
        })

        if (!isThereFilelist) {
          this.$store.commit('videoHistory/setMapWebviewStatePerChannel', {
            channel: ch,
            state: null,
          })
        }
      })

      if (this.isThereIsWebviewActive && targetChannelBuffered.length === 0) {
        this.intentTimeChanges()
        await this.$nextTick()

        this.$store.commit('videoHistory/setHasIntentToTimeChange', true)
        this.$store.commit('videoHistory/resetMapWebviewBufferedTimePerChannel')
      }
    },
  },
}
</script>
